var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-tree',{ref:"menuTree",attrs:{"checkable":true,"blockNode":true,"defaultExpandAll":false,"checkStrictly":false,"treeData":_vm.treeData,"checkedKeys":_vm.value},on:{"check":_vm.handleCheck}})}
var staticRenderFns = []

export { render, staticRenderFns }